import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import FleetGrid from "@/components/FleetGrid";
import SeasonStrip from "@/components/SeasonStrip";
import Standards from "@/components/Standards";
import Locations from "@/components/Locations";
import Footer from "@/components/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-onyx text-bone selection:bg-champagne">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <FleetGrid />
        <SeasonStrip />
        <Standards />
        <Locations />
      </main>
      <Footer />
    </div>
  );
}
